import { DEALER_CONFIG_PAGES } from 'constants/RoutesConstants';
import { useRights } from 'hooks';
import { getCurrentRoute } from 'services/RouterUtils';

import navigationConfig from './settings';

/**
 * @returns {Array<import('./settings').MenuItemGroup>}
 */
const useReducedNavigation = () => {
  const { hasAccess } = useRights();

  const shouldDisplayConfig = hasAccess(DEALER_CONFIG_PAGES.GLOBAL);

  const reducer = (acc, group) => {
    const children = group.children.filter(child => {
      const route = getCurrentRoute(child.to.path);
      return hasAccess(route);
    });

    if (children.length > 0) {
      acc.push({
        ...group,
        children,
      });
    }
    return acc;
  };

  return shouldDisplayConfig ? navigationConfig.reduce(reducer, []) : [];
};

export default useReducedNavigation;
